"use client";

import { useTranslations } from "next-intl";
import React, { useState } from "react";
import { CiFilter } from "react-icons/ci";
import MainSidebar from "../MainSidebar";
import useCustomReactHookForm from "@/hooks/use-custom-react-hook-form";
import GlobalPageFilterSidebar from "./GlobalPageFilterSidebar";
import { filterDefaultValue } from "@/formDefaultValues/form-default-value";
import { filterSchema, TFilterSchema } from "@/schema/filterSchema";
import { useSearchParams, useRouter, usePathname } from "next/navigation";
import { prepareFilterToApi } from "@/utils/utils";

const GlobalPageFilter = () => {
  const t = useTranslations();
  const searchParams = useSearchParams();
  const router = useRouter();
  const pathname = usePathname();
  const [isOpen, setIsOpen] = useState(false);
  const { control, errors, handleSubmit, reset } = useCustomReactHookForm({
    formDefaultValue: filterDefaultValue,
    formSchema: filterSchema,
  });

  const openSidebar = () => setIsOpen(true);

  const onSubmit = (data: TFilterSchema) => {
    const params = new URLSearchParams(searchParams.toString());
    const serialized = prepareFilterToApi(data);

    if (serialized) {
      params.delete("search");
      params.delete("sort");

      params.set("filter", serialized);
    }

    params.set("page", "1");
    params.set("limit", "8");

    router.push(`${pathname}?${params.toString()}`);

    setIsOpen(false);
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="flex items-center">
      <CiFilter
        title={t("Filter")}
        aria-label={t("Filter")}
        size={25}
        onClick={openSidebar}
        className="text-foreground-muted cursor-pointer hover:text-primary transition-all duration-200"
      />

      {isOpen && (
        <MainSidebar setIsOpen={setIsOpen} isOpen={isOpen} reset={reset}>
          <GlobalPageFilterSidebar control={control} errors={errors} />
        </MainSidebar>
      )}
    </form>
  );
};

export default GlobalPageFilter;
